import React from 'react';
import { Banner } from 'Features/MyAccount/PromoBanner/Banner';
import { useStore } from 'Hooks/useStore';

export const PromoBannerContainer = ({ promoBanner, useDetailsBanner, handleClickBanner = null }) => {
  const { routes } = useStore('appConfig');
  const bannerImage = useDetailsBanner ? promoBanner.promotionDetailsBanner : promoBanner.banner;
  const planId = promoBanner.bannerSKU;
  const bannerLink = planId ? `${routes.payment}/${planId}` : null;
  const promoCode = promoBanner.promoCode;

  return (
    <Banner
      image={bannerImage}
      className={promoBanner.className}
      bannerLink={bannerLink}
      promoCode={promoCode}
      planId={planId}
      handleClickBanner={handleClickBanner}
    ></Banner>
  );
};
